// extracted by mini-css-extract-plugin
export default {"label":"FileInput_label__PJba2","labelText":"FileInput_labelText__bBq2y","preview":"FileInput_preview__Lc4zV"};